module.exports = __webpack_public_path__ + "img/works_wechat_anpi_4.c35cf1cc.png";